import { isPlainObject as _isPlainObject } from 'lodash';
import { connect } from 'react-redux';
import { utils } from '@gisatcz/ptr-utils';
import mapTimelineActions from '../../../state/Timeline/MapTimeline/actions';
import mapTimelineSelectors from '../../../state/Timeline/MapTimeline/selectors';
import periodsSelectors from '../../../state/Periods/selectors';
var order = null;
var start = 1;
var length = 1000;
var componentId = "layer_row_item_".concat(utils.uuid());

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$layer;

  var periodsConfig = _isPlainObject(ownProps === null || ownProps === void 0 ? void 0 : (_ownProps$layer = ownProps.layer) === null || _ownProps$layer === void 0 ? void 0 : _ownProps$layer.periods) ? ownProps.layer.periods : null;
  var start = 0;
  var length = 1000;
  var periodKeys = periodsConfig ? mapTimelineSelectors.getPeriodKeysForFilteredSpatialRelations(state, periodsConfig.filterByActive, periodsConfig.filter, order, start, length) : null;
  var periodsByConfig = periodsConfig ? periodsSelectors.getByKeys(state, periodKeys) : null;
  return {
    periodsByConfig: periodsByConfig,
    periodKeys: periodKeys
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onMount: function onMount() {//ensure layers
    },
    usePeriods: function usePeriods(periodsConfig) {
      //ensure spatial relations related to the layer and periods
      var filterByActive = periodsConfig.filterByActive,
          filter = periodsConfig.filter;
      dispatch(mapTimelineActions.useRelationsForLayerRowItem(filterByActive, filter, order, start, length));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps);